require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('svg', Painter);


//////////////////
// WEBPACK FOOTER
// ./~/echarts/~/zrender/lib/svg/svg.js
// module id = 902
// module chunks = 2